var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.611 5.504L6.53 6.586V1.293h-1v5.293L4.449 5.504l-.708.707L6.03 8.5l2.289-2.289-.708-.707zM1.5 9.5a1 1 0 001 1h7a1 1 0 001-1V7h-1v2.5h-7V7h-1v2.5z",
    fill: "#121314"
  })));
}
export default SvgSmall;